import * as Blockly from 'blockly/core';
import { expr, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export const variableDeclarations = new Map<string, string>();

export function register(gen: any): void {
    gen.forBlock['string'] = function (block: Blockly.Block): [string, number] {
        const text = block.getFieldValue('TEXT') ?? '';
        return expr(`"${text}"`);
    };

    gen.forBlock['var_set_number'] = function (block: Blockly.Block): string {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '設定する変数') return '';
        variableDeclarations.set(varName, `float ${varName} = 0;\n`);
        const value = gen.valueToCode(block, 'VALUE', 0) || '0';
        return stmt(`${varName} = ${value}`);
    };

    gen.forBlock['var_set_string'] = function (block: Blockly.Block): string {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '設定する変数') return '';
        variableDeclarations.set(varName, `String ${varName} = "";\n`);
        const value = gen.valueToCode(block, 'VALUE', 0) || '""';
        return stmt(`${varName} = ${value}`);
    };

    gen.forBlock['var_set_bool'] = function (block: Blockly.Block): string {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '設定する変数') return '';
        variableDeclarations.set(varName, `bool ${varName} = false;\n`);
        const value = gen.valueToCode(block, 'VALUE', 0) || 'false';
        return stmt(`${varName} = ${value}`);
    };

    gen.forBlock['var_get_number'] = function (block: Blockly.Block): [string, number] {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '変数') return expr('0');
        variableDeclarations.set(varName, `float ${varName} = 0;\n`);
        return expr(varName);
    };

    gen.forBlock['var_get_string'] = function (block: Blockly.Block): [string, number] {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '変数') return expr('""');
        variableDeclarations.set(varName, `String ${varName} = "";\n`);
        return expr(varName);
    };

    gen.forBlock['var_get_bool'] = function (block: Blockly.Block): [string, number] {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '変数') return expr('true');
        variableDeclarations.set(varName, `bool ${varName} = true;\n`);
        return expr(varName);
    };

    gen.forBlock['var_increment_number'] = function (block: Blockly.Block): string {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '設定する変数') return '';
        variableDeclarations.set(varName, `float ${varName} = 0;\n`);
        const amount = gen.valueToCode(block, 'AMOUNT', 0) || '1';
        const op = block.getFieldValue('OP') as string;
        const operator = op === 'decrement' ? '-=' : '+=';
        return stmt(`${varName} ${operator} ${amount}`);
    };
}
